import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireFeatureGate } from '~/utils/guards';

const BrandPreferencesPage = lazy(
  () => import('~/features/subsidiary-configuration/pages/brand-preferences-page'),
);

const searchSchema = z.object({
  tab: z.enum(['guidelines', 'preferred-restricted']).catch('guidelines'),
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/subsidiary-preferences/brand-preferences',
)({
  validateSearch: searchSchema,
  beforeLoad: requireFeatureGate('subsidiary_configuration'),
  component: RouteComponent,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <BrandPreferencesPage initialTab={tab} />
    </Suspense>
  );
}
